module.exports = __webpack_public_path__ + "static/media/Siam-Exchange-iPhoneX.af71dd7f.png";